export default "__VITE_ASSET__DpMapAF3__"